import React from "react";
import { MessageCircle } from "lucide-react";
import { useForm } from "../../context/FormContext";
import { CONTACT } from "../../config";

export function MobileCTA() {
  const { requestAvailability } = useForm();
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-cream/95 backdrop-blur-md border-t-2 border-berry/20 px-4 py-3 flex items-center gap-3"
    >
      <button
        data-testid="mobile-request-btn"
        onClick={() => requestAvailability()}
        className="btn flex-1 bg-berry text-cream border-2 border-berry py-3.5 shadow-[3px_3px_0_#2A1020]"
      >
        Inquire About a Booking
      </button>
      <a
        data-testid="mobile-whatsapp-btn"
        href={`${CONTACT.whatsappBase}?text=${encodeURIComponent("Hi! I have a question about DMediaClub.")}`}
        target="_blank"
        rel="noreferrer"
        className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-charcoal bg-butter text-charcoal"
        aria-label="Ask on WhatsApp"
      >
        <MessageCircle strokeWidth={2} size={20} />
      </a>
    </div>
  );
}
